import NovalueCheck from './NoValueCheck';

export default (value) => {
  if(NovalueCheck(value)) return NovalueCheck(value);

  value = +value;

  // Non-NPO blood glucose: ปกติ < 200 mg/dL
  if(value < 200) {
    return {
      title: 'น้ำตาลปกติ',
      color: 'green',
      caption: 'น้ำตาลปกติ',
      suggest: 'รับประทานอาหารและออกกำลังกายตามปกติ'
    };
  }

  return {
    title: 'น้ำตาลสูง',
    color: 'red',
    caption: 'น้ำตาลสูง',
    suggest: 'รับประทานยาอย่างสม่ำเสมอตามที่แพทย์สั่ง พบนักกำหนดอาหารและควบคุมอาหารตามคำแนะนำ'
  };
}
